import { Message } from '../../models/message';
import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss']
})
export class MessageItemComponent implements OnInit {

  // tslint:disable-next-line: no-input-rename
  @Input('message')
  // tslint:disable-next-line: variable-name
  private _message: Message;
  public get message(): Message {
    return this._message;
  }
  public set message(value: Message) {
    this._message = value;
  }

  constructor() { }

  ngOnInit() {
  }

}
